// store/admin/question-bank/store/_actions.js
import * as types from './_actionTypes';

// Create single question
export const createQuestion = (questionData) => ({
  type: types.CREATE_QUESTION_REQUEST,
  payload: questionData
});

export const createQuestionSuccess = (data) => ({
  type: types.CREATE_QUESTION_SUCCESS,
  payload: data
});

export const createQuestionFailure = (error) => ({
  type: types.CREATE_QUESTION_FAILURE,
  payload: error
});

// Bulk create questions
export const bulkCreateQuestions = (questions) => ({
  type: types.BULK_CREATE_QUESTIONS_REQUEST,
  payload: questions
});

export const bulkCreateQuestionsSuccess = (data) => ({
  type: types.BULK_CREATE_QUESTIONS_SUCCESS,
  payload: data
});

export const bulkCreateQuestionsFailure = (error) => ({
  type: types.BULK_CREATE_QUESTIONS_FAILURE,
  payload: error
});

// Get questions by course
export const getQuestionsByCourse = (courseId) => ({
  type: types.GET_QUESTIONS_BY_COURSE_REQUEST,
  payload: { courseId }
});

export const getQuestionsByCourseSuccess = (data) => ({
  type: types.GET_QUESTIONS_BY_COURSE_SUCCESS,
  payload: data
});

export const getQuestionsByCourseFailure = (error) => ({
  type: types.GET_QUESTIONS_BY_COURSE_FAILURE,
  payload: error
});

// Update question
export const updateQuestion = (questionId, updateData) => ({
  type: types.UPDATE_QUESTION_REQUEST,
  payload: { questionId, updateData }
});

export const updateQuestionSuccess = (data) => ({
  type: types.UPDATE_QUESTION_SUCCESS,
  payload: data
});

export const updateQuestionFailure = (error) => ({
  type: types.UPDATE_QUESTION_FAILURE,
  payload: error
});

// Delete question
export const deleteQuestion = (questionId) => ({
  type: types.DELETE_QUESTION_REQUEST,
  payload: { questionId }
});

export const deleteQuestionSuccess = (questionId) => ({
  type: types.DELETE_QUESTION_SUCCESS,
  payload: questionId
});

export const deleteQuestionFailure = (error) => ({
  type: types.DELETE_QUESTION_FAILURE,
  payload: error
});

// Bulk delete questions
export const bulkDeleteQuestions = (ids) => ({
  type: types.BULK_DELETE_QUESTIONS_REQUEST,
  payload: { ids }
});

export const bulkDeleteQuestionsSuccess = (ids) => ({
  type: types.BULK_DELETE_QUESTIONS_SUCCESS,
  payload: ids
});

export const bulkDeleteQuestionsFailure = (error) => ({
  type: types.BULK_DELETE_QUESTIONS_FAILURE,
  payload: error
});

// Local state management
export const setSelectedCourse = (courseId) => ({
  type: types.SET_SELECTED_COURSE,
  payload: courseId
});

export const setSelectedQuestion = (question) => ({
  type: types.SET_SELECTED_QUESTION,
  payload: question
});

export const clearQuestionBankError = () => ({
  type: types.CLEAR_QUESTION_BANK_ERROR
});

export const clearQuestionBankSuccess = () => ({
  type: types.CLEAR_QUESTION_BANK_SUCCESS
});

export const resetQuestionBank = () => ({
  type: types.RESET_QUESTION_BANK
});
